import { ReactNode } from 'react';
import { articleContainerStyle } from './article-container.style';

type ArticleContainerProps = {
	title: string;
	children: ReactNode;
}

export const ArticleContainer = ({
	title,
	children,
}: ArticleContainerProps) => {
	return (
		<div className={articleContainerStyle.content}>
			<div className={articleContainerStyle.title}>{title}</div>
			{ children }
		</div>
	);
}